import React, { lazy, Suspense } from "react";
import { withBusinessOnly } from "../../helpers/subscriptionPlan";

const BulkUploadKeywords = lazy(() => import("./BulkUploadKeywords"));

const WrappedBulkUploadKeywords = withBusinessOnly(BulkUploadKeywords);

const LoadableCustomUpdate = (props) => (
  <Suspense fallback={"Loading..."}>
    <WrappedBulkUploadKeywords {...props} />
  </Suspense>
);

export default LoadableCustomUpdate;
